/**
 * 定义store部分模块常量，便于全局引用
 */
export const StoreModuleName = {
  COMMON: 'common',
  ENVIRONMENT: 'environment',
  USER: 'user',
  COURSE: 'course',
  EXAM_ANSWER: 'exam-answer',
  EXAM_RESULT: 'exam-result',
  EXAM_DETAIL: 'exam-detail',
  EXAM_ANALYZE: 'exam-analyze',
  APP_SETTING: 'app-setting',
};
